<template>
  <div v-loading="loading" style="height: 300px;width: 100%;"></div>
</template>

<script>
import { debounce } from "@/utils/common";

export default {
  props: {
    simid: {
      type: [String,Number],
      default: 0
    },
    list: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,

      chart: null,
      chartOption: {
        grid: {
          right: 50,
          left: 30,
          bottom: 30,
          // top: 10,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          formatter: '{b} 使用流量: {c}M'
        },
        legend: {
          data: ["使用统计"],
          y: 'bottom',
          x: 'center'
        },
        xAxis: {
          name: "日期",
          data: [],
          nameTextStyle: {
            color: "#303133",
          },
          boundaryGap: true,
        },
        yAxis: {
          type: "value",
          name: "流量（M）",
          nameTextStyle: {
            color: "#303133",
            nameLocation: "start",
          },
        },
        series: [
          {
            name: "使用统计",
            type: "line",
            smooth: false,
            barWidth: "61.8%",
            itemStyle: {
              color: "#07c160",
            },
            data: [],
          },
        ],
      },
    };
  },
  created() {
  },

  watch: {
    list(val) {
      if(val) this.setChart()
    }
  },

  mounted() {
    this.initChart();
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, "teenager");
      this.chart.setOption(this.chartOption);
    },
    setChart() {
      this.chartOption.xAxis.data = this.list.x_data
      this.chartOption.series[0].data = this.list.y_data
      this.chartOption.legend.data[0] = this.list.month
      this.chartOption.series[0].name = this.list.month
      this.chart.setOption(this.chartOption);
    },
  },
};
</script>
